import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.deleteMessage.loading;
export const sendMessageErrorMessage = (state: RootState) =>
  state.deleteMessage.error;
export const deleteMessageDataResponse = (state: RootState) =>
  state.deleteMessage.deleteMessageResponse;
